import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Fingerprint2 from 'fingerprintjs2';

import InfoMessage from '../../components/InfoMessage';

import Form from '../Form';
import Alert from '../Alert';

import { setContactInfo, setMessage, setFingerprint } from './actionCreator';
import { initializeSpecificForm, FORM_STEP2, FORM_STEP3 } from '../Form/actionCreator';
import { updatedFetch } from '../../utils/fetch/actionCreators';
import { defaultPersonType } from '../../utils/commonFormsConfig';

import { getMessage } from './selectors';
import { getFetchAuth } from '../../components/HeaderLogin/selectors';

import { getCountries } from '../Step2/utils';
import { baseURL } from '../../utils/fetch/axios';

class App extends Component {
	state = {
		cardType: 0,
		fetching: true
	};

	componentDidMount() {
    const { setFingerprint, fetchAuth, initializeSpecificForm, updatedFetch, setMessage } = this.props;

		Fingerprint2.get((components) => {
			const values = components.map(component => component.value);
			const fingerprint = Fingerprint2.x64hash128(values.join(''), 31); // eslint-disable-line
			setFingerprint(fingerprint);
    });

		const url = baseURL + '/UserData/userdashboard';
		updatedFetch('GET', url, {}, [], [(response) => setContactInfo(response.hasProfile, response.contactEmail)], [], fetchAuth).then((user) => {
			if(user.hasContract) {
				if(!user.hasConfirmedOTP) {
					if(user.quoteType === 'Flat' || user.quoteType === 'Ricaricabile') {
						setMessage('confirm');
					}
					if(user.quoteType === 'Consumo' && user.dashboard.length === 0) {
						setMessage('loading');
					}
				} else {
					// controllo la tipologia di contratto
					if(user.dashboard.length > 0) {
						this.setState({ cardType: user.dashboard[0].idTipoTessera }, () => {
							if(user.dashboard[0].idTipoTessera === 3 && user.quoteType !== 'Consumo')  {
								// ho una tessera a consumo e sto iniziando un nuovo contratto
								setMessage('confirm');
							}
							if(user.dashboard[0].idTipoTessera !== 3)  {
								// ho una tessera a flat/ricaricabile
								setMessage('active');
							}
						});
					} else {
						setMessage('active');
					}
				}
			}

			if(user.hasProfile) {
				const stepData = this.getStepData(user);
				initializeSpecificForm(FORM_STEP2, stepData.step2);
				initializeSpecificForm(FORM_STEP3, stepData.step3);
			} else {
				initializeSpecificForm(FORM_STEP2, { personType: defaultPersonType, firstName: user.firstName, lastName: user.lastName });
			}

			this.setState({ fetching: false });
		});
	}

	getStepData = (user) => {
		const { t } = this.props;

		let phone1 = "";
		if(user.phone1 !== "") {
			phone1 = user.phone1Prefix.slice(1) + user.phone1;
		}
		let mobilePhone1 = "";
		if(user.mobilePhone1 !== "") {
			mobilePhone1 = user.mobilePhone1Prefix.slice(1) + user.mobilePhone1;
		}
		// const countryLabel = getCountries(t).filter(c => c.value === user.country)[0].label;
		const nazioneLabel = getCountries(t).filter(c => c.value === user.nazione)[0].label;

		return {
			step2: {
				personType: user.tipoPersona.toString(),
				firstName: user.firstName,
				lastName: user.lastName,
				// country: {
				// 	value: user.country,
				// 	label: countryLabel
				// },
				phone1: phone1,
				phone1Prefix: user.phone1Prefix,
				mobilePhone1: mobilePhone1,
				mobilePhone1Prefix: user.mobilePhone1Prefix,
				dataDiNascita: new Date(user.dataDiNascita),
				ragioneSociale: user.ragioneSociale,
				rappresentanteLegaleNome: user.rappresentanteLegaleNome,
				rappresentanteLegaleCognome: user.rappresentanteLegaleCognome,
				partitaIva: user.partitaIva,
				codiceFiscaleAzienda: user.codiceFiscaleAzienda,
				pec: user.pec,
				codiceSDI: user.codiceSDI
			},
			step3: {
				address: user.indirizzo,
				numeroCivico: user.numeroCivico,
				frazione: user.frazione,
				citta: user.citta,
				provincia: user.provincia,
				cap: user.cap,
				nazione: {
					value: user.nazione,
					label: nazioneLabel
				},
				codiceFiscale: user.codiceFiscale,
				targaVeicolo: user.targaVeicolo,
				modelloVeicolo: user.modelloVeicolo
			}
		};
	};

	render() {
    const { t, i18n, message } = this.props;
		const { cardType, fetching } = this.state;

		return <Fragment>
			{
				!fetching && <div className='row'>
					{
						message.show ? <div className='col'>
							<InfoMessage type={message.type} t={t}></InfoMessage>
						</div> : <Fragment>
							<div className='col col-12 col-xl-8 offset-xl-2'>
								<Form t={t} i18n={i18n} cardType={cardType}></Form>
							</div>
						</Fragment>
					}
				</div>
			}
			<Alert t={t}></Alert>
		</Fragment>;
	}
}

const mapStateToProps = (state) => {
	return {
		fetchAuth: getFetchAuth(state),
		message: getMessage(state).toJS()
	};
};

const mapDispatchToProps = {
	updatedFetch,
	initializeSpecificForm,
	setFingerprint,
	setMessage
};

App.propTypes = {
	fetchAuth: PropTypes.object,
	updatedFetch: PropTypes.func,
	initializeSpecificForm: PropTypes.func,
	setFingerprint: PropTypes.func,
	setMessage: PropTypes.func,
	message: PropTypes.object,
	i18n: PropTypes.object,
	t: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
